import { ICONS, type IconName } from "./icon-paths";

/** Material Symbols Rounded（08 5章）。必ず文字と一緒に使う（飾りとして読み上げない） */
export function Icon({ name, filled = false, size = 24, className }: { name: IconName; filled?: boolean; size?: number; className?: string }) {
  return (
    <svg aria-hidden="true" focusable="false" width={size} height={size} viewBox="0 -960 960 960" fill="currentColor" className={className} style={{ flex: "none" }}>
      <path d={filled ? ICONS[name].fill : ICONS[name].line} />
    </svg>
  );
}
export type { IconName };
